import { toast } from "react-toastify";
import { fetchUserIp, loadColorConfig } from "../constants/common";
import API from "../services";
import { setActiveWallet, setExchangeAuthData, setSportBookAuthData, setUserDetails, setUserThumbnail, setWallets } from "./authReducer";
import { UserDetails } from "../models/UserDetails";
import { themes } from "../components/WalletComponents/MyProfile/MyProfile";


export const getGameUrl = (provider: string) => {
  return async (dispatch: Function) => {
    try {
      const userIp = await fetchUserIp();
      const response = await API.post(`/webapp/get-login-url`, {
        userKey: sessionStorage.getItem("userKey"),
        tgProviderId: provider,
        clientIp: userIp,
      });

      if (response.data.status !== "RS_OK") {
        toast.error(response.data.errorDescription);
        return Promise.reject(response.data.errorDescription);
      }

      if (response.data?.sessionUrl !== "") {
        await setSportsAuthData(dispatch, provider, response.data.sessionUrl);
      }
      return Promise.resolve(response.data.sessionUrl);
    } catch (e) {
      console.error("API Error:", e);
      toast.error("Failed to get game URL. Please try again.");
      return Promise.reject(e);
    }
  };
};

export const getUserBalance = () => async (dispatch: any) => {
  let response: any;
  try {
    response = await API.post(`/webapp/get-user-balance`, {
      userKey: sessionStorage.getItem("userKey"),
    });
  } catch (e) {
    return;
  }

  // if (response.data.status !== "RS_OK") {
  //   toast.error(response.data.errDescription);
  // }

  if (response && response.data.wallets) {
    dispatch(setWallets(response.data?.wallets));
    dispatch(setActiveWallet(response?.data?.activeWallet))
  }
};

export const getRefId = () => async (dispatch: any) => {
  try {
    const userKey = sessionStorage.getItem("userKey");
    if (!userKey) {
      console.error("User ID not found in session storage");
      return;
    }
    const response = await API.post(`/users/get-user-details`, {
      userKey: userKey,
    });

    if (!response || response.data.status !== "RS_OK") {
      console.error("Error retrieving user details or invalid status");
      return;
    }

    const fetchedUserDetails: UserDetails = response.data?.userDetails;

    const validThemes = [
      'blue', 'purple', 'green', 'yellow', 'orange', // Existing themes
      'CSK', 'DC', 'GT', 'KKR', 'LSG', 'MI', 'PK', 'RR', 'RCB', 'SRH' // IPL Teams
    ] as const;
    type ThemeType = typeof validThemes[number];

    if (fetchedUserDetails) {
      dispatch(setUserDetails(fetchedUserDetails));
      dispatch(setUserThumbnail(fetchedUserDetails?.Thumbnail));
      if (validThemes.includes(fetchedUserDetails.Theme as ThemeType)) {
        setTheme(fetchedUserDetails.Theme as ThemeType);
      } else {
        setTheme('blue');
      }
    } else {
      console.error("User details not found in response");
    }
  } catch (error) {
    console.error("Error fetching user details:", error);
  }
};

const setTheme = (themeName: keyof typeof themes) => {
  const selectedTheme = themes[themeName];

  if (selectedTheme) {
    loadColorConfig(selectedTheme)
  } else {
    console.error('Theme not found');
  }
};


const setSportsAuthData = async (dispatch: Function, provider: string, url: string) => {
  return new Promise((resolve) => {
    const parsedUrl = new URL(url);

    const authData = {
      token: parsedUrl.searchParams.get("token"),
      operatorId: parsedUrl.searchParams.get("operatorId"),
      partnerId: parsedUrl.searchParams.get("partnerId"),
      providerId: parsedUrl.searchParams.get("providerId"),
      currency: parsedUrl.searchParams.get("currency"),
      rate: parseFloat(parsedUrl.searchParams.get("rate") || "1"),
    };

    // Set the extracted data
    if (provider === "EX123") {
      dispatch(setExchangeAuthData(authData));
    } else {
      dispatch(setSportBookAuthData(authData));
    }

    resolve(true);
  });
};

export function setTextColor(hexColor: any) {
  var r = parseInt(hexColor.substring(1, 3), 16);
  var g = parseInt(hexColor.substring(3, 5), 16);
  var b = parseInt(hexColor.substring(5, 7), 16);
  var yiq = (r * 299 + g * 587 + b * 114) / 1000;

  return yiq >= 186 ? "dark-text" : "light-text";
}

export const setUserSportsView = (isClassic: boolean) => {
  try {
    let result = null;
    result = API.post(`/users/change-sports-view`, {
      isClassic: isClassic,
    });

  } catch (err) {
    console.log(err);
  }
};